// checks if onKeyDown event is space or enter key
export const keyboardEnterOrSpaceClick = (
  event: { key: string },
  triggeredAccessibiltyFunction: (...args: unknown[]) => void,
) => {
  if (event.key === "Enter" || event.key === " ") {
    triggeredAccessibiltyFunction();
  }
};
